"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPhoneCountryCode = exports.ECountryIso = void 0;
var ECountryIso;
(function (ECountryIso) {
    ECountryIso["AT"] = "AT";
    ECountryIso["DE"] = "DE";
    ECountryIso["BE"] = "BE";
    ECountryIso["BG"] = "BG";
    ECountryIso["DK"] = "DK";
    ECountryIso["EE"] = "EE";
    ECountryIso["FI"] = "FI";
    ECountryIso["FR"] = "FR";
    ECountryIso["GI"] = "GI";
    ECountryIso["GR"] = "GR";
    ECountryIso["GB"] = "GB";
    ECountryIso["HK"] = "HK";
    ECountryIso["IE"] = "IE";
    ECountryIso["IT"] = "IT";
    ECountryIso["HR"] = "HR";
    ECountryIso["LV"] = "LV";
    ECountryIso["LI"] = "LI";
    ECountryIso["LT"] = "LT";
    ECountryIso["LU"] = "LU";
    ECountryIso["MT"] = "MT";
    ECountryIso["MC"] = "MC";
    ECountryIso["NL"] = "NL";
    ECountryIso["PL"] = "PL";
    ECountryIso["PT"] = "PT";
    ECountryIso["RO"] = "RO";
    ECountryIso["SE"] = "SE";
    ECountryIso["CH"] = "CH";
    ECountryIso["SK"] = "SK";
    ECountryIso["SI"] = "SI";
    ECountryIso["ES"] = "ES";
    ECountryIso["ZA"] = "ZA";
    ECountryIso["CZ"] = "CZ";
    ECountryIso["HU"] = "HU";
    ECountryIso["CY"] = "CY";
})(ECountryIso = exports.ECountryIso || (exports.ECountryIso = {}));
var EPhoneCountryCode;
(function (EPhoneCountryCode) {
    EPhoneCountryCode["AT"] = "+43";
    EPhoneCountryCode["DE"] = "+49";
    EPhoneCountryCode["BE"] = "+32";
    EPhoneCountryCode["BG"] = "+359";
    EPhoneCountryCode["DK"] = "+45";
    EPhoneCountryCode["EE"] = "+372";
    EPhoneCountryCode["FI"] = "+358";
    EPhoneCountryCode["FR"] = "+33";
    EPhoneCountryCode["GI"] = "+350";
    EPhoneCountryCode["GR"] = "+30";
    EPhoneCountryCode["GB"] = "+44";
    EPhoneCountryCode["HK"] = "+852";
    EPhoneCountryCode["IE"] = "+353";
    EPhoneCountryCode["IT"] = "+39";
    EPhoneCountryCode["HR"] = "+385";
    EPhoneCountryCode["LV"] = "+371";
    EPhoneCountryCode["LI"] = "+423";
    EPhoneCountryCode["LT"] = "+370";
    EPhoneCountryCode["LU"] = "+352";
    EPhoneCountryCode["MT"] = "+356";
    EPhoneCountryCode["MC"] = "+377";
    EPhoneCountryCode["NL"] = "+31";
    EPhoneCountryCode["PL"] = "+48";
    EPhoneCountryCode["PT"] = "+351";
    EPhoneCountryCode["RO"] = "+40";
    EPhoneCountryCode["SE"] = "+46";
    EPhoneCountryCode["CH"] = "+41";
    EPhoneCountryCode["SK"] = "+421";
    EPhoneCountryCode["SI"] = "+386";
    EPhoneCountryCode["ES"] = "+34";
    EPhoneCountryCode["ZA"] = "+27";
    EPhoneCountryCode["CZ"] = "+420";
    EPhoneCountryCode["HU"] = "+36";
    EPhoneCountryCode["CY"] = "+357";
})(EPhoneCountryCode = exports.EPhoneCountryCode || (exports.EPhoneCountryCode = {}));
